import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Item } from '../../models/item';
import { generalService } from '../../services/general.service';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';
import { event } from 'jquery';
import * as moment from 'moment';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-add-update',
  templateUrl: './product-add-edit.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class ProductAddEditComponent implements OnInit {
  user: any
  selectedFile: File = null;
  previewUrl: string | ArrayBuffer = null;
  enabledImage: boolean = false;
  enabledInventorySection: boolean = false;
  // Para mostrar existencia en Update
  currentStock: number = 0;
  onFileSelected(event: any, fileInput: HTMLInputElement): void {
    const file = event.target.files[0];
    const maxSizeKB = 500;
    const maxSizeBytes = maxSizeKB * 1024;

    if (file.size > maxSizeBytes) {
      this.selectedFile = null;
      this.previewUrl = ""
      console.warn(fileInput)
      fileInput.value = ''; // <- Limpia el input para que no aparezca el nombre del archivo
      this._generalService.toastCall('El archivo supera el límite de ${maxSizeKB} KB');
      return;
    }
    if (file && file.type.startsWith('image/')) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = () => (this.previewUrl = reader.result);
      reader.readAsDataURL(file);
    } else {
      this.selectedFile = null;
      this.previewUrl = ""
      fileInput.value = ''; // <- Limpia el input para que no aparezca el nombre del archivo
      this._generalService.toastCall('Por favor, selecciona solo imágenes');
    }
  }
  /***************************INFINITE SELECT**********************************/
  public viewDataProduct: any[];
  public viewDataProduct2: any[];
  @ViewChild('infiniteSelect') selectElem: MatSelect;
  @ViewChild('infiniteSelect2') selectElem2: MatSelect;
  private itemsShow = 10;
  private itemsShow2 = 10;
  private filteredItemsShowSat = 10;
  private filteredItemsShowSat2 = 10;
  private arrayFilteredSat = undefined;
  private arrayFilteredSatUnit = undefined;
  private isFilteredSat = false;
  private isFilteredSatUnit = false;
  /***************************INFINITE SELECT**********************************/


  public title = 'Producto ';
  public isUpdate = false;
  public containsTaxGeneral = true;
  public product: Item;
  public productForm: FormGroup;
  private productId = undefined;
  public matOptions: any;
  public disabledContainer = false;
  public selectedStatus: number;
  public filtroSATCodes: any[];
  public filtroSATUnits: any[];
  public subFamilies: ItemSubFamily[] = [];
  public selectedFamily = null;
  public lastItem: string = '';

  private loacs;

  materialPeligrosoOption = [
    { id_mh: 0, value: 'No' },
    { id_mh: 1, value: 'Si' }
  ]
  public listamaterialesPeligrosos: any[] = [];
  public listaembalaje: any[] = [];

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private _generalService: generalService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<ProductAddEditComponent>) {
    this.product = new Item();
    this.productId = this.route.snapshot.paramMap.get('id');
    this.productForm = new FormGroup({});
    this.product.unitsPerContainer = 1;
    this.buildMatOptionsList();

    this.user = JSON.parse(sessionStorage.getItem("user"));
    console.warn(this.user)
  }

  async ngOnInit() {
    this.loacs = sessionStorage.getItem("acslo");


    this._generalService.metodoCallParams({ 'COMPANY_ID': this.user.COMPANY_ID }, 'item/consultEnableImagenProduct', true)
      .subscribe(result => {
        console.warn(result)
        this.enabledImage = result
      }, error => {
        // Custom error handler
      });

    this._generalService.metodoCallParams(
      { COMPANY_ID: this.user.COMPANY_ID },
      'item/consultEnableInventariosProduct', // <-- ajusta el nombre real
      true
    ).subscribe(result => {
      this.enabledInventorySection = result;
    });

    this.buildProductForm();
    await this.consultLastProduct();
    await this.consultIVA();
    await this.consultarMaterialEmbalaje();
    await this.consultFamily();
    await this.consultSubFamily();
    await this.consultSATcode();
    await this.consultSATunit();
    this.consultAllItemLookUp();
    this.validateRoute();

    /***************************INFINITE SELECT**********************************/
    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent());
    this.selectElem2.onOpen.subscribe(() => this.registerPanelScrollEvent2());
    /***************************INFINITE SELECT**********************************/
  }

  validateRoute() {
    console.log(this.dialogData);

    if (this.productId === 'N') {
      this.isUpdate = false;
    } else if (parseInt(this.productId)) {
      this.isUpdate = true;
      this.getProduct(this.productId);
    } else if (this.dialogData && this.dialogData.producto) {
      this.isUpdate = false;
      this.product = this.dialogData.producto;
      //this.product.containsTax = true;
      this.productId = this.product.itemId;
      this.setFamilyBySubFamily(this.product.itemSubfamilyId);
      this.selectedStatus = this.product.status;
    } else {
      this.router.navigate(['product/N']);
    }
  }

  getProduct(productId) {
    this._generalService.metodoCall(`item/consultItem?itemId=${productId}`)
      .subscribe(item => {
        item = JSON.parse(item);
        console.warn(item)
        if (item.length > 0) {
          this.product = item[0];
          this.title += this.product.SKU;
          //this.previewUrl=this.product.FILE
          //this.product.containsTax = true;
          this.validarMH(item[0].HAZARDOUS_MATERIAL);
          this.productId = this.product.itemId;
          this.setFamilyBySubFamily(this.product.itemSubfamilyId);
          this.selectedStatus = this.product.status;
          this.moverSeleccion();
          this.moverSeleccionSATUnit();
        }
      }, error => {
        // Custom error handler
      });
  }

  buildMatOptionsList() {
    this.matOptions = new Object();
    this.matOptions.families = [];
    this.matOptions.subFamilies = [];
    this.matOptions.minimumUnits = [];
    this.matOptions.containers = [];
    this.matOptions.status = [
      { code: 1, meaning: 'Activo' },
      { code: 0, meaning: 'Inactivo' },
    ];

    this.matOptions.tax = [
      { code: true, meaning: 'Si' },
      { code: false, meaning: 'No' },
    ];

    this.product.status = this.matOptions.status[0].code;
    this.matOptions.SATcodes = [];
    this.matOptions.SATunits = [];
  }

  consultFamily(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.loacs, 'itemFamily/consultItemFamilies')
        .subscribe(families => {
          families = JSON.parse(families);
          this.matOptions.families = families;
          resolve();
        }, error => {
          // Custom error handler
          reject();
        });
    });
  }

  consultSubFamily(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.loacs, 'itemSubFamily/consultItemSubFamilies')
        .subscribe(subFamilies => {
          subFamilies = JSON.parse(subFamilies);
          this.subFamilies = subFamilies;
          resolve();
        }, error => {
          // Custom error handler
          reject();
        });
    });
  }

  consultSATcode(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall('itemCodeSAT/consultItemSATcodes')
        .subscribe(SATcodes => {
          SATcodes = JSON.parse(SATcodes);
          this.matOptions.SATcodes = SATcodes;
          this.filtroSATCodes = this.matOptions.SATcodes;

          /***************************INFINITE SELECT**********************************/
          this.viewDataProduct = this.matOptions.SATcodes.slice(0, 10);
          /***************************INFINITE SELECT**********************************/

          resolve();
        }, error => {
          // Custom error handler
          reject();
        });
    });
  }

  consultSATunit(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall('itemCodeSAT/consultItemSATunits')
        .subscribe(SATunits => {
          SATunits = JSON.parse(SATunits);
          this.matOptions.SATunits = SATunits;
          this.filtroSATUnits = this.matOptions.SATunits;

          /***************************INFINITE SELECT**********************************/
          this.viewDataProduct2 = this.matOptions.SATunits.slice(0, 10);
          /***************************INFINITE SELECT**********************************/

          resolve();
        }, error => {
          // Custom error handler
          reject();
        });
    });
  }

  moverSeleccion() {
    /***************************INFINITE SELECT**********************************/
    const index = this.matOptions.SATcodes.findIndex(x => x.itemSATcodeId == this.product.itemSATcode);
    var a = this.matOptions.SATcodes.splice(index, 1);
    this.matOptions.SATcodes.unshift(a[0]);

    this.viewDataProduct = this.matOptions.SATcodes.slice(0, 10);
    /***************************INFINITE SELECT**********************************/
  }

  moverSeleccionSATUnit() {
    /***************************INFINITE SELECT**********************************/
    const index = this.matOptions.SATunits.findIndex(x => x.itemSATUnitId == this.product.itemSATUnitId);
    var a = this.matOptions.SATunits.splice(index, 1);
    this.matOptions.SATunits.unshift(a[0]);

    this.viewDataProduct2 = this.matOptions.SATunits.slice(0, 10);
    /***************************INFINITE SELECT**********************************/
  }

  consultAllItemLookUp() {
    this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultAllItemLookUp')
      .subscribe(itemLookUps => {
        itemLookUps = JSON.parse(itemLookUps);
        this.matOptions.minimumUnits = itemLookUps;
        this.matOptions.containers = itemLookUps;
      }, error => {
        // Custom error handler
      });
  }

  consultIVA() {
    this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultIVA')
      .subscribe(itemIVA => {
        itemIVA = JSON.parse(itemIVA);
        if (itemIVA.length > 0) {
          this.containsTaxGeneral = false;
        }
        else {
          this.containsTaxGeneral = true;
        }
      }, error => {
        // Custom error handler
      });
  }

  consultLastProduct() {
    this._generalService.metodoCallParams(this.loacs, 'itemLookUp/lastProduct')
      .subscribe(result => {
        let item = typeof result === 'string' ? JSON.parse(result) : result;
        // 👇 Guardamos el código en la variable
        this.lastItem = item[0].SKU;
      }, error => {
        console.error('Error al consultar último producto:', error);
      });
  }

  familyChange(option: MatOptionSelectionChange) {
    if (option.isUserInput) {
      this.getSubFamiliesByFamily(option.source.value);
    }
  }

  getSubFamiliesByFamily(familyId) {
    this.matOptions.subFamilies =
      this.subFamilies.filter(subFamily => subFamily.itemFamilyId === familyId);
  }

  setFamilyBySubFamily(subFamilyId: number) {
    const subFamily =
      this.subFamilies.filter(subFamily => subFamily.itemSubFamilyId === subFamilyId);

    if (subFamily.length > 0) {
      this.selectedFamily = subFamily[0].itemFamilyId;
    }
  }

  backward() {
    this.router.navigate(['app/product']);
  }

  buildProductForm() {
    this.productForm = this.formBuilder.group({
      // General data
      family: this.formBuilder.control(null, [Validators.required]),
      subFamily: this.formBuilder.control(null, [Validators.required]),
      SKU: this.formBuilder.control(null, [Validators.required, Validators.maxLength(20)]),
      name: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      longDescription: this.formBuilder.control(null, [Validators.maxLength(500)]),
      shortDescription: this.formBuilder.control(null, [Validators.maxLength(100)]),
      status: this.formBuilder.control(null, [Validators.required]),
      // Units
      minimumUnit: this.formBuilder.control(null, [Validators.required]),
      container: this.formBuilder.control({ disabled: true }, [Validators.required]),
      stock: this.formBuilder.control(null),
      minimo: this.formBuilder.control(null, [Validators.max(999999999999999), Validators.min(1), this.onlyNumbersValidator()]),
      maximo: this.formBuilder.control(null, [Validators.max(999999999999999), Validators.min(1), this.onlyNumbersValidator()]),
      // Prices
      baseSalePrice: this.formBuilder.control(null, [Validators.required, Validators.max(9999999999.99), Validators.min(0.01)]),
      basePurchasePrice: this.formBuilder.control(null, [Validators.required, Validators.max(9999999999.99), Validators.min(0.01)]),
      // Not required
      barcode: this.formBuilder.control(null, [Validators.maxLength(50), this.onlyNumbersValidator()]),
      unitsPerContainer: this.formBuilder.control(null, [Validators.max(999999999999999), Validators.min(1), this.onlyNumbersValidator()]),
      containsTax: this.formBuilder.control({ value: null, disabled: true }, [Validators.required]),
      SATcode: this.formBuilder.control(null, []),
      SATUnit: this.formBuilder.control(null, []),
      //Carta Porte
      GROSS_WEIGHT: this.formBuilder.control(null, []),
      NET_WEIGHT: this.formBuilder.control(null, []),
      DIMENSIONS: this.formBuilder.control(null, []),
      HAZARDOUS_MATERIAL: this.formBuilder.control(null, []),
      HAZARDOUS_MATERIAL_ID: this.formBuilder.control({ value: null, disabled: true }),
      BILL_PACKAGING_ID: this.formBuilder.control({ value: null, disabled: true }),
      //inventarios
      initialStock: this.formBuilder.control(0), // Alta
      inventoryObservations: this.formBuilder.control(''),
      addStock: this.formBuilder.control(0),     // Update

    });
  }

  onlyNumbersValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const nameRe = new RegExp('^[0-9]+$');
      const onlyNumbers = nameRe.test(control.value);
      return (control.value === '' || onlyNumbers || !control.value) ? null : { 'onlyNumbers': { value: control.value } };
    };
  }

  unitsPerContainerChange() {
    if (this.product.unitsPerContainer == 1) {
      this.productForm.controls['container'].disable();
    } else {
      this.productForm.controls['container'].enable();
    }
    this.minimumUnitChange();
  }

  containerChange() {
    if (this.product.containerId == this.product.minimumUnitId) {
      this.product.minimumUnitId = null;
    }
  }

  minimumUnitChange() {
    if (this.product.unitsPerContainer == 1) {
      this.product.containerId = this.product.minimumUnitId;
    } else if (this.product.minimumUnitId == this.product.containerId) {
      this.product.containerId = null;
    }
  }

  submitProductForm() {
    if (this.productForm.valid) {
      this.cleanInvalidProductFields();
      if (this.isUpdate) {
        this.updateProduct();
      } else {
        this.createProduct();
      }
    }
  }

  cleanInvalidProductFields() {
    if (this.product.barcode && this.product.barcode.trim().length === 0) {
      this.product.barcode = null;
    }
  }

  createProduct() {
    this.product.loacs = sessionStorage.getItem("acslo");

    const formData = new FormData();
    formData.append('item', JSON.stringify(this.product));
    if (this.enabledImage && this.selectedFile != null) {
      formData.append('imagen', this.selectedFile, this.selectedFile.name);
    }

    //this._generalService.metodoCallParams(this.product, 'item/add', true)
    this._generalService.metodoCallParamsMulti(formData, 'item/add', true)
      .subscribe(result => {
        this._generalService.toastCall(result.message);

        const createdItemId = parseInt(result.data, 10);

        if (Number.isNaN(createdItemId) || createdItemId <= 0) {
          this._generalService.toastCall('No se pudo obtener el ID del producto.');
          return;
        }

        this.product.itemId = createdItemId;

       const finish = () => {
        if (this.dialogData && this.dialogData.producto) {
          this.cerrarModal(this.product);
        } else {
          this.backward();
        }
      };

      const qty = Number(this.productForm.value.initialStock || 0);

      if (this.enabledInventorySection && qty > 0) {
        // ✅ Espera a que termine inventario
        this.registrarEntradaInventario(
          createdItemId,
          qty,
          () => {
            this._generalService.toastCall('Inventario inicial registrado');
            finish();
          },
          (e) => {
            const msg = (e as any)?.error?.message || e?.message || e || 'Error registrando inventario';
            this._generalService.toastCall(msg);
            // Decide si aún así cierras o no:
            // Si quieres NO cerrar cuando falla inventario, deja sin finish().
            // Si quieres cerrar aunque falle, descomenta:
            // finish();
          }
        );
      } else {
        // ✅ No hay inventario: cerrar normal
        finish();
      }

    }, error => {
      const msg = error.error?.message || error.error || "Ocurrió un error inesperado";
      this._generalService.toastCall(msg);
    });
}

  updateProduct() {
    this.product.loacs = sessionStorage.getItem("acslo");
    const formData = new FormData();
    formData.append('item', JSON.stringify(this.product));
    console.warn(JSON.stringify(this.product))
    console.warn(this.product)
    if (this.enabledImage && this.selectedFile != null) {
      formData.append('imagen', this.selectedFile, this.selectedFile.name);
    }
    this._generalService.metodoCallParamsMulti(formData, 'item/update')
      //this._generalService.metodoCallParams(this.product, 'item/update')
      .subscribe(result => {
        this._generalService.toastCall(result.message);
        this.backward();
      }, error => {
        // Custom error handler
      });
  }

  onKeyUpSATcode(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSat = this.filtroSATCodes.filter((obj) => {
        return (obj.SATcode.includes(val.currentTarget.value) > 0 || obj.DESCRIPTION.toLowerCase().includes(val.currentTarget.value.toLowerCase()));
      })

      arr = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
      this.isFilteredSat = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSat = false;
      this.filteredItemsShowSat = 10;
      this.arrayFilteredSat = undefined;
      arr = this.matOptions.SATcodes.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    //this.matOptions.SATcodes = arr;
    this.viewDataProduct = arr;
    /***************************INFINITE SELECT**********************************/
  }

  onKeyUpSATunit(val: any) {
    let arr2: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSatUnit = this.filtroSATUnits.filter((obj) => {
        return obj.Name.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr2 = this.arrayFilteredSatUnit.slice(0, this.filteredItemsShowSat2);
      this.isFilteredSatUnit = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSatUnit = false;
      this.filteredItemsShowSat2 = 10;
      this.arrayFilteredSatUnit = undefined;
      arr2 = this.matOptions.SATunits.slice(0, this.itemsShow2);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    //this.matOptions.SATcodes = arr;
    this.viewDataProduct2 = arr2;
    /***************************INFINITE SELECT**********************************/
  }

  /*
 onKeyUpSATcode(searchCode: any) {
  let filteredCodes = this.matOptions.SATcodes;
  if (searchCode != "") {
    filteredCodes = filteredCodes.filter((obj) => {            
      return obj.SATcode.indexOf(searchCode) != -1; });
    } 
  }
  */

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if (this.isFilteredSat) {
        if (this.filteredItemsShowSat < this.arrayFilteredSat.length) {
          this.filteredItemsShowSat += 10;
          this.viewDataProduct = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
        }
      } else {
        if (this.itemsShow < this.matOptions.SATcodes.length) {
          this.itemsShow += 10;
          this.viewDataProduct = this.matOptions.SATcodes.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/

  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent2() {
    const panel2 = this.selectElem2.panel.nativeElement;
    panel2.addEventListener('scroll', event => this.loadAllOnScroll2(event));
  }

  loadAllOnScroll2(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if (this.isFilteredSatUnit) {
        if (this.filteredItemsShowSat2 < this.arrayFilteredSatUnit.length) {
          this.filteredItemsShowSat2 += 10;
          this.viewDataProduct2 = this.arrayFilteredSatUnit.slice(0, this.filteredItemsShowSat2);
        }
      } else {
        if (this.itemsShow2 < this.matOptions.SATunits.length) {
          this.itemsShow2 += 10;
          this.viewDataProduct2 = this.matOptions.SATunits.slice(0, this.itemsShow2);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/

  cerrarModal(productoAgregado = null) {
    console.log(productoAgregado);
    this.dialogRef.close(productoAgregado)
  }

  //------------------Carta Porte

  consultarMaterialEmbalaje() {
    let metodo = 'item/getMaterialEmbalaje';
    const params = {
      loacs: sessionStorage.getItem('acslo')
    };

    this._generalService.metodoCallParams(params, metodo).subscribe(
      (result) => {
        const tableResult = JSON.parse(result);
        this.listamaterialesPeligrosos = tableResult.Table;
        this.listaembalaje = tableResult.Table1;


      },
      (error) => {
        const errorMsj = error as any;
        console.log(errorMsj);
      }
    );
  }

  validarMH(event: any) {

    if (event == 0 || event.value == 0) {
      this.productForm.controls['HAZARDOUS_MATERIAL_ID'].reset();
      this.productForm.controls['BILL_PACKAGING_ID'].reset();
      this.productForm.controls['HAZARDOUS_MATERIAL_ID'].disable();
      this.productForm.controls['BILL_PACKAGING_ID'].disable();

    } else {
      this.productForm.controls['HAZARDOUS_MATERIAL_ID'].enable();
      this.productForm.controls['BILL_PACKAGING_ID'].enable();
    }
  }

  private registrarEntradaInventario(
    itemId: number,
    qty: number,
    onDone: () => void,
    onError: (msg: any) => void
  ) {
    const tipo = 'agregar';
    const linkInsert = 'EntradaAlmacen/entradaInsert/';

    const entradaModel: any = {
      noEntrada: null,
      tipoEntrada: 1, // TODO: default
      almacen: 11,     // TODO: default 4 para pruebas, 11 es el bueno
      statusEntrada: 1,
      idUsuario: this.user.USER_ID ?? this.user.idUsuario,
      observaciones: this.productForm.value.inventoryObservations || '',
      idSucursal: this.user.ORGANIZATION_ID ?? this.user.idSucursal ?? 0,
      fechaRegistro: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    this._generalService
      .metodoCallParamsPutPost(tipo, entradaModel, linkInsert)
      .subscribe((result: any) => {
        let idEntrada = 0;

        try {
          const parsed = JSON.parse(result);
          idEntrada = parsed[0].idEntrada;
        } catch (e) {
          onError('No se pudo obtener idEntrada (respuesta inválida).');
          return;
        }

        const params = [{
          idEntrada: idEntrada,
          idRegistro: 0,
          idProducto: itemId,
          cantidad: qty,
          piezasContenedor: 1, // TODO: default / unitsPerContainer?
          idUsuario: this.user.USER_ID ?? this.user.idUsuario,
          fechaUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
          statusRegistro: 1
        }];

        this._generalService
          .metodoCallParamsPutPost('agregar', params, 'EntradaAlmacen/entradaDetallesFunction/')
          .subscribe(() => {
            onDone();
          }, (error) => {
            onError(error);
          });

      }, (error) => {
        onError(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/product/add-edit/product-add-edit.component.ts